import {fetch} from "utils/dataAccess";

/**
 * Asks the API to (re)generate the invoice documents a retailer should have had for `year` but never got.
 * Idempotent: shipments that already carry an invoice document for the retailer are skipped.
 *
 * @param {string} retailerId uuid of the retailer to catch up
 * @param {number} year       the year to catch up
 *
 * @return {Promise<{year: number, blocked: boolean, blockedReason: ?string, candidates: number, generated: number, skipped: number, failed: number}>}
 */
export default function invoiceCatchUp(retailerId, year) {
    return fetch(`/retailers/${retailerId}/invoice_catch_up`, {
        method: "POST",
        body: JSON.stringify({year}),
        signal: null,
    }, false, true).then(response => response.json());
}
